import React from "react";

interface Props {
  sermon: Sermon;
  play: () => void;
  currentSong: Song;
}

export default function SermonItem(props: Props) {
  return (
    <div
      className={`flex items-center rounded-md ${
        props.currentSong?.id === props.sermon.id ? "bg-gray-300" : " bg-transparent"
      }`}
    >
      <div className="flex-shrink-0 w-20 h-20">
        <img
          src={props.sermon.image?.url}
          className="object-cover object-center w-full h-full rounded-md"
        />
      </div>

      <div className="flex-1 px-3 py-2">
        <p className="text-sm font-bold leading-4">{props.sermon.title}</p>
        <p className="text-xs font-bold leading-4 text-gray-500 line-clamp-2">
          {props.sermon.description}
        </p>
      </div>
    </div>
  );
}
